module.exports = __webpack_public_path__ + "img/businessWorkorder.f8b0660d.svg";